import auth from '@/api/auth';
import session from '@/api/session';
import {
  LOGIN_BEGIN,
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  LOGOUT,
  REMOVE_TOKEN,
  SET_TOKEN,
} from './types';

const TOKEN_STORAGE_KEY = 'TOKEN_STORAGE_KEY';
// const isProduction = process.env.NODE_ENV === 'production';

const initialState = {
  authenticating: false,
  error: false,
  token: null,
  username: null,
  user_type: null
};

const getters = {
  isAuthenticated: state => !!state.token,
  username: state => state.username,
  user_type: state => state.user_type
};

const actions = {
  login({ commit }, { username, password }) {
    commit(LOGIN_BEGIN);
    return auth.login(username, password)
      .then(({ data }) => {
        commit(SET_TOKEN, data.key);
        commit('user_type', data.user.type_permissions);
      })
      .then(() => {
        commit(LOGIN_SUCCESS);
        commit('username', username);
      }).catch(() => {
        commit(LOGIN_FAILURE)
      });
  },
  logout({ commit }) {
    return auth.logout()
      .then(() => commit(LOGOUT))
      .finally(() => commit(REMOVE_TOKEN));
  },
  initialize({ commit }) {
    const token = localStorage.getItem(TOKEN_STORAGE_KEY);
    const username = localStorage.getItem('username');
    const user_type = localStorage.getItem('user_type');

    // if (isProduction && token) {
    //   commit(REMOVE_TOKEN);
    // }

    if (token) {
      commit(SET_TOKEN, token);
      commit('username', username);
      commit('user_type', user_type);
    }
  },
};

const mutations = {
  username(state, username) {
    localStorage.setItem('username', username)
    state.username = username;
  },
  user_type(state, user_type) {
    localStorage.setItem('user_type', user_type)
    state.user_type = user_type;
  },
  [LOGIN_BEGIN](state) {
    state.authenticating = true;
    state.error = false;
  },
  [LOGIN_FAILURE](state) {
    state.authenticating = false;
    state.error = true;
  },
  [LOGIN_SUCCESS](state) {
    state.authenticating = false;
    state.error = false;
  },
  [LOGOUT](state) {
    state.token = null;
    state.authenticating = false;
    state.error = false;
  },
  [SET_TOKEN](state, token) {
    localStorage.setItem(TOKEN_STORAGE_KEY, token);
    session.defaults.headers.Authorization = `Token ${token}`;
    state.token = token;
  },
  [REMOVE_TOKEN](state) {
    localStorage.removeItem(TOKEN_STORAGE_KEY);
    delete session.defaults.headers.Authorization;
    state.token = null;
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
